/**LCFPIContext.js — Lagos Climate Finance Pipeline Initiative SSOT Context */
import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import client from "@/api/client";
const Ctx = createContext(null);
export const useLCFPI = () => useContext(Ctx);
export function LCFPIProvider({ children }) {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const r = await client.get("/lcfpi/dashboard");
      setDashboard(r.data);
    } catch(e) { console.error("LCFPIContext:", e); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { reload(); }, []);
  const kpis = dashboard?.kpis || {};
  const sectors = dashboard?.sector_breakdown || {};
  const topProjects = dashboard?.top_projects || [];
  const recentSubmissions = dashboard?.recent_submissions || [];
  const ecoLabels = dashboard?.eco_label_distribution || {};
  return (
    <Ctx.Provider value={{ dashboard, loading, reload, kpis, sectors, topProjects, recentSubmissions, ecoLabels }}>
      {children}
    </Ctx.Provider>
  );
}
